/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BoothApplicationDto } from '../../models/booth-application-dto';
import { CreateBoothApplicationDto } from '../../models/create-booth-application-dto';

export interface BoothApplicationControllerCreateV1$Params {
      body: CreateBoothApplicationDto
}

export function boothApplicationControllerCreateV1(http: HttpClient, rootUrl: string, params: BoothApplicationControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BoothApplicationDto>> {
  const rb = new RequestBuilder(rootUrl, boothApplicationControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BoothApplicationDto>;
    })
  );
}

boothApplicationControllerCreateV1.PATH = '/api/v1/booth-application';
